import { useContext } from "react";

import exerciseContext from "./index";

export const useExercise = () => {
  const exercise = useContext(exerciseContext);
  return exercise;
};